import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFeedsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GetFeedsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly feeds: ReadonlyArray<{ readonly __typename?: 'YalperFeed', readonly id: number, readonly name: string, readonly accountId: string, readonly accountName: string, readonly updatedAt: string, readonly itemCount: number }> } | null } | null };

export type GetTrackingFeedsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GetTrackingFeedsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly trackingFeeds?: ReadonlyArray<{ readonly __typename?: 'YalperTrackingFeedsFeed', readonly id: number, readonly name: string, readonly accountId: string, readonly accountName: string }> | null } | null } | null };

export type SaveTrackingFeedsSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperTrackingFeedsSettingsInput;
}>;


export type SaveTrackingFeedsSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveTrackingFeedsSettings: boolean };


export const GetFeedsDocument = gql`
    query GetFeeds($companyId: ID!) {
  currentUser {
    company(id: $companyId) {
      feeds {
        id
        name
        accountId
        accountName
        updatedAt
        itemCount
      }
    }
  }
}
    `;

/**
 * __useGetFeedsQuery__
 *
 * To run a query within a React component, call `useGetFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetFeedsQuery(baseOptions: Apollo.QueryHookOptions<GetFeedsQueryPage, GetFeedsQueryVariables> & ({ variables: GetFeedsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedsQueryPage, GetFeedsQueryVariables>(GetFeedsDocument, options);
      }
export function useGetFeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedsQueryPage, GetFeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedsQueryPage, GetFeedsQueryVariables>(GetFeedsDocument, options);
        }
export function useGetFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeedsQueryPage, GetFeedsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeedsQueryPage, GetFeedsQueryVariables>(GetFeedsDocument, options);
        }
export type GetFeedsQueryHookResult = ReturnType<typeof useGetFeedsQuery>;
export type GetFeedsLazyQueryHookResult = ReturnType<typeof useGetFeedsLazyQuery>;
export type GetFeedsSuspenseQueryHookResult = ReturnType<typeof useGetFeedsSuspenseQuery>;
export type GetFeedsQueryResult = Apollo.QueryResult<GetFeedsQueryPage, GetFeedsQueryVariables>;
export const GetTrackingFeedsDocument = gql`
    query GetTrackingFeeds($companyId: ID!) {
  currentUser {
    company(id: $companyId) {
      trackingFeeds {
        id
        name
        accountId
        accountName
      }
    }
  }
}
    `;

/**
 * __useGetTrackingFeedsQuery__
 *
 * To run a query within a React component, call `useGetTrackingFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackingFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackingFeedsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetTrackingFeedsQuery(baseOptions: Apollo.QueryHookOptions<GetTrackingFeedsQueryPage, GetTrackingFeedsQueryVariables> & ({ variables: GetTrackingFeedsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackingFeedsQueryPage, GetTrackingFeedsQueryVariables>(GetTrackingFeedsDocument, options);
      }
export function useGetTrackingFeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackingFeedsQueryPage, GetTrackingFeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackingFeedsQueryPage, GetTrackingFeedsQueryVariables>(GetTrackingFeedsDocument, options);
        }
export function useGetTrackingFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrackingFeedsQueryPage, GetTrackingFeedsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrackingFeedsQueryPage, GetTrackingFeedsQueryVariables>(GetTrackingFeedsDocument, options);
        }
export type GetTrackingFeedsQueryHookResult = ReturnType<typeof useGetTrackingFeedsQuery>;
export type GetTrackingFeedsLazyQueryHookResult = ReturnType<typeof useGetTrackingFeedsLazyQuery>;
export type GetTrackingFeedsSuspenseQueryHookResult = ReturnType<typeof useGetTrackingFeedsSuspenseQuery>;
export type GetTrackingFeedsQueryResult = Apollo.QueryResult<GetTrackingFeedsQueryPage, GetTrackingFeedsQueryVariables>;
export const SaveTrackingFeedsSettingsDocument = gql`
    mutation SaveTrackingFeedsSettings($settings: YalperTrackingFeedsSettingsInput!) {
  saveTrackingFeedsSettings(settings: $settings)
}
    `;
export type SaveTrackingFeedsSettingsMutationFn = Apollo.MutationFunction<SaveTrackingFeedsSettingsMutationPage, SaveTrackingFeedsSettingsMutationVariables>;

/**
 * __useSaveTrackingFeedsSettingsMutation__
 *
 * To run a mutation, you first call `useSaveTrackingFeedsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTrackingFeedsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTrackingFeedsSettingsMutation, { data, loading, error }] = useSaveTrackingFeedsSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveTrackingFeedsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveTrackingFeedsSettingsMutationPage, SaveTrackingFeedsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTrackingFeedsSettingsMutationPage, SaveTrackingFeedsSettingsMutationVariables>(SaveTrackingFeedsSettingsDocument, options);
      }
export type SaveTrackingFeedsSettingsMutationHookResult = ReturnType<typeof useSaveTrackingFeedsSettingsMutation>;
export type SaveTrackingFeedsSettingsMutationResult = Apollo.MutationResult<SaveTrackingFeedsSettingsMutationPage>;
export type SaveTrackingFeedsSettingsMutationOptions = Apollo.BaseMutationOptions<SaveTrackingFeedsSettingsMutationPage, SaveTrackingFeedsSettingsMutationVariables>;